import Vue from 'vue'
import { Drawer, MessageBox, Button, RadioGroup, Select, Option, Row, Col, Carousel, CarouselItem, Rate, Icon, Collapse, Tabs, TabPane, CollapseItem, Input, Autocomplete, Checkbox, CheckboxGroup, InputNumber, Pagination, Message, Radio, Form, FormItem, Popover, Loading, Table, TableColumn, Upload, Dialog, Dropdown, DropdownMenu, DropdownItem, Image, Notification, Popconfirm, Timeline, TimelineItem, InfiniteScroll } from 'element-ui'

Vue.use(Button).use(Drawer).use(RadioGroup).use(Timeline).use(TimelineItem).use(Popconfirm).use(Image).use(Dropdown).use(DropdownMenu).use(DropdownItem).use(Row).use(Option).use(Select).use(Col).use(Carousel).use(CarouselItem).use(Rate).use(Icon).use(Collapse).use(Tabs).use(TabPane).use(CollapseItem).use(Input).use(Autocomplete).use(Checkbox).use(Form).use(FormItem).use(CheckboxGroup).use(InputNumber).use(Pagination).use(Radio).use(Popover).use(Loading).use(Table).use(TableColumn).use(Upload).use(Dialog).use(InfiniteScroll)

/**
 * @default Pc端尽量用ElementUI框架，移动端尽量都用VantUI框架
 */

// 封装消息提醒
Vue.prototype.$message = function(message = '开发ing...', type) {
  if (message === '开发ing...' || message === '') return false
  Message({ message, type: type || ['success', 'warning', 'info', 'error'][Math.floor(Math.random() * 4)] })
}
Vue.prototype.$notify = Notification

Vue.prototype.$confirm = MessageBox.confirm

// 开发模块提醒
Vue.prototype.dev = () => Vue.prototype.$message()
Vue.prototype.$loading = Loading.service
